import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Switch, Route} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {headTitle} from 'shells/document/head-title';
import {MainContentContainer} from 'shells/layout/main-content-container';

import {EmailFeatureGate} from '../../limits/feature-gates/email-feature-gate';

import {AutomatedEmailPausedBanner} from '../automated-email-paused-banner';
import {hasEmailSequenceCapability} from '../has-email-sequence-capability';

import {AutomationsNeedsAttention} from './automations-needs-attention';
import {AutomationsReadyToSend} from './automations-ready-to-send';
import {AutomationsSending} from './automations-sending';
import {EmailAutomationsTitleBar} from './email-automations-title-bar';
import {getTitles} from './get-titles';

export function EmailAutomationsPage(props: ContextRouter) {
    const hasScheduledEmailsCapability = hasEmailSequenceCapability();

    return (
        <React.Fragment>
            <Helmet>
                <title>
                    {headTitle([getTitles(props.location.pathname).pageTitle, 'Email automations'])}
                </title>
            </Helmet>
            <EmailAutomationsTitleBar />
            <MainContentContainer includesHeader={false} whiteBackground={true}>
                {!hasScheduledEmailsCapability ? (
                    <EmailFeatureGate />
                ) : (
                    <>
                        <AutomatedEmailPausedBanner />
                        <Switch>
                            <Route
                                path='/email/automations/sending'
                                component={AutomationsSending}
                            />
                            <Route
                                path='/email/automations/needs-attention'
                                component={AutomationsNeedsAttention}
                            />
                            <Route
                                path='/email/automations/ready-to-send'
                                component={AutomationsReadyToSend}
                            />
                        </Switch>
                    </>
                )}
            </MainContentContainer>
        </React.Fragment>
    );
}
